<textarea [(ngModel)]="desiredSlug" (input)="checkSlugAvailability()" placeholder="Slug" (keydown.enter)="$event.preventDefault()"></textarea>
<mat-icon class="good" *ngIf="checked && available">check_circle_outline</mat-icon>
<mat-icon class="warning" *ngIf="checked && !available">error_outline</mat-icon>
<div class="message">
    <span>{{error}}</span>
</div>